import { Redirect, Route } from 'react-router-dom';

import { useIsManager } from '@twilio/frontline-shared/store/ChatSessionState';
import { PAGES } from '../../paths';

export function ManagerRoute({ children, ...rest }: any) {
    const isManager = useIsManager();
    return <Route {...rest}>{isManager ? children : <Redirect to={PAGES.CONVERSATIONS} />}</Route>;
}
